import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-progress',
  templateUrl: './form-progress.component.html',
  styleUrls: ['./form-progress.component.scss']
})
export class FormProgressComponent implements OnInit {

  @Input() vm: IProgressViewModel;
  
  constructor() { }

  ngOnInit(): void {
  }
}

/**
 * 
 */
export interface IProgressViewModel {
  valueNow: number;
}
